import ButtonV2 from "../../../../../src/components/ui/button/v2";
import { CheckCheck, Download, Mail } from "lucide-react";

const LeaReportHeader: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-t-xl">
      <div className="w-[1032px] mx-auto h-[52px] px-2.5 py-1.5 flex items-center justify-between">
        {/* Title */}
        <span className="truncate text-[#0A0A0A] font-sans text-lg font-medium leading-7">
          Law Enforcement Agency Report
        </span>

        {/* Actions */}
        <div className="flex items-center gap-3">
          <ButtonV2
            variant="outline-primary"
            size="md"
            prefix={<CheckCheck className="h-4 w-4" />}
          >
            Status
          </ButtonV2>

          <ButtonV2
            variant="outline-primary"
            size="md"
            prefix={<Mail className="h-4 w-4" />}
          >
            Send Email
          </ButtonV2>

          <ButtonV2
            variant="outline-primary"
            size="md"
            prefix={<Download className="h-4 w-4" />}
          >
            Download
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

export default LeaReportHeader;